var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "RMApprove"
  }, [_c('div', {
    staticClass: "animated fadeIn mb-2"
  }, [_c('div', {}, [_c('legend', {
    on: {
      "click": function($event) {
        _vm.isReport = !_vm.isReport
      }
    }
  }, [_c('span', [_vm._v("Reports")]), _vm._v(" "), (!_vm.isReport) ? _c('span', {
    staticStyle: {
      "float": "inline-end"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]) : _vm._e(), _vm._v(" "), (_vm.isReport) ? _c('span', {
    staticStyle: {
      "float": "inline-end"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.isReport) ? _c('div', {}, [_c('b-card', [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0px !important"
    }
  }, [_c('h5', [_vm._v(" Zone Wise Recovery Summary to YTD (Year - " + _vm._s(_vm.year) + ") "), _c('sub', [_vm._v("Total Amount & Count for Loss - RM Approved & Recovered - By HR/Finance")])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-xl-3 col-md-3 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-success",
    staticStyle: {
      "box-shadow": "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px"
    }
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("RM Approved Count")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.RMApprovalCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-3 py-2"
  }, [_c('div', {
    staticClass: "card bg-danger text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-danger",
    staticStyle: {
      "box-shadow": "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px"
    }
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-money fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("RM Approved Amount")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.GrandTotalRMApproveYTD) + "  ₹")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-3 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-success",
    staticStyle: {
      "box-shadow": "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px"
    }
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Loss Recovered Count")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.RecoveredAmountCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-3 py-2"
  }, [_c('div', {
    staticClass: "card bg-danger text-white h-100"
  }, [_c('div', {
    staticClass: "card-body bg-danger",
    staticStyle: {
      "box-shadow": "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px"
    }
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-money fa-4x"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Loss Rcovered Amount")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.GrantTotalRecovedYTD) + "  ₹")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "batches table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Zone")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bucket")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("M-3")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("M-2")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("M-1")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("MTD ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("YTD")])])])]), _vm._v(" "), _c('tbody', [(_vm.dashboardDetails.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dashboardDetails), function(item) {
    return [_c('tr', [_c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s(item.hubzonename) + "  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s(item.HubName) + " ")]), _vm._v(" "), _c('td', [_vm._v("Loss - RM Approved")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.RMA3rdLastMonth))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.RMA2ndLastMonth))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.RMALastMonth))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.RMAmtd) + " ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.RMAytd))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Recovered - By HR/Finance")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.FR3rdLastMonth))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.FR2ndLastMonth))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.FRLastMonth))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.FRmtd))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(item.FRytd))])])])]
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.detailsLoading
    },
    on: {
      "update:active": function($event) {
        _vm.detailsLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showMoreData()
      }
    }
  }, [_vm._v(" Load  More")])])])], 1)])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.isShow = !_vm.isShow
      }
    }
  }, [_c('legend', [_vm._v(_vm._s(_vm.heading) + "\n           "), (!_vm.isShow) ? _c('span', {
    staticStyle: {
      "float": "inline-end"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('span', {
    staticStyle: {
      "float": "inline-end"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.isShow) ? _c('div', {}, [_c('b-card', [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0px !important"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchData.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fromDate",
      "type": "Date",
      "name": "fromDate",
      "placeholder": "Enter From Date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "placeholder": "Enter To Date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Debit From")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.debitFrom),
      expression: "debitFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "debitFrom",
      "id": "debitFrom"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.debitFrom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Debit--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ServiceCenter"
    }
  }, [_vm._v("Service Center")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Courier"
    }
  }, [_vm._v("Super Agent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Coloader"
    }
  }, [_vm._v("Coloader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Vendor"
    }
  }, [_vm._v("Local Vendor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NetworkVendor"
    }
  }, [_vm._v("Network Vendor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Store"
    }
  }, [_vm._v("Store")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RSC"
    }
  }, [_vm._v("RSCOwner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BranchDebit"
    }
  }, [_vm._v(" BranchDebit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentType),
      expression: "ShipmentType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ShipmentType",
      "id": "ShipmentType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ShipmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-Select Shipment Type -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Delivery"
    }
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTO"
    }
  }, [_vm._v("RTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DTO"
    }
  }, [_vm._v("DTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RVP"
    }
  }, [_vm._v("RVP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Vertical")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Vertical),
      expression: "Vertical"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "Vertical",
      "id": "Vertical"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Vertical = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2B"
    }
  }, [_vm._v("B2B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2C"
    }
  }, [_vm._v("B2C")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Zone")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubzoneid),
      expression: "hubzoneid"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "hubzoneid",
      "id": "hubzoneid"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubzoneid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getHubsByZoneId($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Hub Zone--")]), _vm._v(" "), _vm._l((_vm.hubZoneList), function(hubZones) {
    return _c('option', {
      domProps: {
        "value": hubZones.HubZoneId
      },
      on: {
        "click": function($event) {
          return _vm.getHubList(hubZones.HubZoneId)
        }
      }
    }, [_vm._v(_vm._s(hubZones.hubzonename))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubStateId),
      expression: "hubStateId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "hubStateId",
      "id": "hubStateId"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubStateId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getCitiesbyState($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Hub State--")]), _vm._v(" "), _vm._l((_vm.hubStateList), function(hubStates) {
    return _c('option', {
      domProps: {
        "value": hubStates.HubStateId
      }
    }, [_vm._v(_vm._s(hubStates.HubState))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubCityId),
      expression: "hubCityId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "hubCityId",
      "id": "hubCityId"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubCityId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getHubsByCities($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Hub City--")]), _vm._v(" "), _vm._l((_vm.hubCitybyStateList), function(hubCities) {
    return _c('option', {
      domProps: {
        "value": hubCities.CityId
      }
    }, [_vm._v(_vm._s(hubCities.HubCity))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("SOC (Span of Control)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AOR),
      expression: "AOR"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "AOR",
      "id": "AOR"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.AOR = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getHubsByAOR(_vm.AOR)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select SOC--")]), _vm._v(" "), _vm._l((_vm.AORList), function(AORid) {
    return _c('option', {
      domProps: {
        "value": AORid.SOC
      }
    }, [_vm._v(_vm._s(AORid.SOC))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Center Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CenterType),
      expression: "CenterType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CenterType",
      "id": "CenterType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CenterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getServiceCentreList(_vm.CenterType)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Center --")]), _vm._v(" "), _vm._l((_vm.CenterTypeList), function(CenterTypes) {
    return _c('option', {
      domProps: {
        "value": CenterTypes.upper
      }
    }, [_vm._v(_vm._s(CenterTypes.upper))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Service Center")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "--select servicecenter-",
      "label": "HubName",
      "track-by": "HubID",
      "options": _vm.filteredHubList,
      "multiple": true,
      "taggable": true,
      "loading": _vm.isLoading
    },
    model: {
      value: (_vm.hubID),
      callback: function($$v) {
        _vm.hubID = $$v
      },
      expression: "hubID"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("UserName")]), _vm._v(" "), _c('span', {
    staticClass: "input-group"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usernames),
      expression: "usernames"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "text",
      "id": "useremail",
      "name": "username",
      "placeholder": "Please enter user email"
    },
    domProps: {
      "value": (_vm.usernames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usernames = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Shipping Id")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumbers),
      expression: "awbnumbers"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbnumbers')
    },
    attrs: {
      "rows": "4",
      "name": "awbnumbers",
      "id": "awbnumbers"
    },
    domProps: {
      "value": (_vm.awbnumbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "textarea-style",
    staticStyle: {
      "display": "block",
      "color": "blue"
    }
  }, [_vm._v(" (Note: Use comma (,) for multiple AWB numbers)\n                       ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Source")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.source),
      expression: "source"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "source",
      "id": "source"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.source = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("--All--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Potential Risk Tagged"
    }
  }, [_vm._v("Potential Lost")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lost Notified Manually"
    }
  }, [_vm._v("Lost Notified Manually")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pickup loss"
    }
  }, [_vm._v("Auto Pickup Loss")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" \n                       "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]), _vm._v(" \n                       "), _c('span', {
    staticClass: "btn btn-primary linkforspan",
    on: {
      "click": _vm.downloadCsv
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Export")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.ExportRmApproveLoaderBtn
    },
    on: {
      "update:active": function($event) {
        _vm.ExportRmApproveLoaderBtn = $event
      }
    }
  })], 1)])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchflag == true),
      expression: "searchflag == true"
    }],
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 mb-2"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Total Selected : " + _vm._s(_vm.totalSelectedRecords) + "  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mb-2"
  }, [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Total Record: " + _vm._s(_vm.totalRecords) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-2"
  }, [_c('span', [_vm._v("Total Debit Amount: "), _c('b', [_vm._v(_vm._s(_vm.totalDebitAmount) + " ₹")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 mb-2",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.selectedItems.length == 0
    },
    on: {
      "click": _vm.approveAllRecolrd
    }
  }, [_vm._v("Approve")]), _vm._v(" \n                  "), (!_vm.isPotentialDebitsPresent) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit",
      "disabled": _vm.selectedItems.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.approveBranchDebit('Rejected')
      }
    }
  }, [_vm._v("Reject")]) : _vm._e(), _vm._v(" \n                  ")]), _vm._v(" "), (_vm.isFacility) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.selectedItems.length == 0 || !_vm.isApprove
    },
    on: {
      "click": function($event) {
        return _vm.approveBranchDebit('Self/Branch')
      }
    }
  }, [_vm._v("Convert to self debit")]), _vm._v(" \n             ")]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.RmApproveLoaderBtn
    },
    on: {
      "update:active": function($event) {
        _vm.RmApproveLoaderBtn = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "batches table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "batchTable",
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', {
    staticClass: "thead"
  }, [_c('tr', [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllItems),
      expression: "selectAllItems"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllItems) ? _vm._i(_vm.selectAllItems, null) > -1 : (_vm.selectAllItems)
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      },
      "change": function($event) {
        var $$a = _vm.selectAllItems,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllItems = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllItems = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Action ")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Source Type")]), _vm._v(" "), _c('th', [_vm._v("Zone")]), _vm._v(" "), _c('th', [_vm._v("Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Client")]), _vm._v(" "), _c('th', [_vm._v(" Total Shipment Value")]), _vm._v(" "), _c('th', [_vm._v("Penalty")]), _vm._v(" "), _c('th', [_vm._v("Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" Debit From")]), _vm._v(" "), _c('th', [_vm._v("Debit Concern - Debit From Id")]), _vm._v(" "), _c('th', [_vm._v("Raise Debit Date")]), _vm._v(" "), _c('th', [_vm._v("Debit CreatedBy")]), _vm._v(" "), _c('th', [_vm._v("Comments")])])]), _vm._v(" "), _c('tbody', [(_vm.ShipmentData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ShipmentData), function(val) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItems),
        expression: "selectedItems"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": val.ShippingID,
        "checked": Array.isArray(_vm.selectedItems) ? _vm._i(_vm.selectedItems, val.ShippingID) > -1 : (_vm.selectedItems)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItems = $$c
          }
        }, function($event) {
          return _vm.calculateselectedcount($event, val)
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getRaiseRMDebitNoteForEdit(val.ShippingID)
        }
      }
    }, [_vm._v("Edit / "), _c('br'), _vm._v("RMApprove")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getShipmentslog(val.ShippingID)
        }
      }
    }, [_vm._v(_vm._s(val.ShippingID ? val.ShippingID : '-'))])]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(_vm._f("updateSourceTypelabel")(val.sourcetype, val.ispotentiallost)))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.HubZoneName ? val.HubZoneName : '-'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.HubName ? val.HubName : ''))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.ClientName ? val.ClientName : '-'))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getDebitAmountPopup(val.ShipmentLostMasterID)
        }
      }
    }, [_vm._v(_vm._s(val.NetShipmentValue ? val.NetShipmentValue : '0.00'))])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Penalty ? val.Penalty : "0.00"))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getDebitAmountPopup(val.ShipmentLostMasterID)
        }
      }
    }, [_vm._v(_vm._s(val.DebitAmount ? val.DebitAmount : '0.00'))])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Status ? _vm.getModifiedStatus(val.Status) : '-'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DebitFromType ? val.DebitFromType : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [(val.shipmentlostdebitdetails && val.shipmentlostdebitdetails.length == 1) ? _c('p', [_vm._v("\n                           " + _vm._s(val.shipmentlostdebitdetails[0].DebitFrom) + " -\n                            " + _vm._s(val.shipmentlostdebitdetails[0].DebitFromType == 'ServiceCenter' ? val.shipmentlostdebitdetails[0].UserID :
      val.shipmentlostdebitdetails[0].DebitFromType == 'Coloader' ? val.shipmentlostdebitdetails[0].ColoaderID :
      val.shipmentlostdebitdetails[0].DebitFromType == 'Vendor' || val.DebitFromType == 'NetworkVendor' ? val.shipmentlostdebitdetails[0].VehicleVendorID :
      val.shipmentlostdebitdetails[0].DebitFromType == 'Courier' ? val.shipmentlostdebitdetails[0].CourierID :
      val.shipmentlostdebitdetails[0].DebitFromType == 'Store' || val.DebitFromType == 'RSC' || val.DebitFromType == 'BranchDebit' ? val.shipmentlostdebitdetails[0].DebitID :
      ''))]) : (val.shipmentlostdebitdetails && val.shipmentlostdebitdetails.length > 1) ? _c('p', [_c('button', {
      staticClass: "btn btn-primary btn-xs",
      staticStyle: {
        "border-radius": "0px",
        "padding": "0.3rem 0.5rem"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showDebitFromModal(val.ShippingID)
        }
      }
    }, [_vm._v("\n                             Show Details")])]) : _c('p', [_vm._v(" -\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(_vm._f("moment2")(val.DebitDate)))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(val.CreatedBy ? val.CreatedBy : '-'))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(val.Comments ? val.Comments : '-'))])])
  })], 2)])]), _vm._v(" "), _c('div', [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.modelValue),
      callback: function($$v) {
        _vm.modelValue = $$v
      },
      expression: "modelValue"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title1"
  }, [_vm._v("Approval Debit Status")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingGroupIdLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingGroupIdLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Message")])])]), _vm._v(" "), _c('tbody', [(_vm.approvalDebitResultStatus.length > 0) ? _vm._l((_vm.approvalDebitResultStatus), function(row, index) {
    return _c('tr', {
      key: index,
      style: (row.code == '200' ? _vm.styleObjectSuccess : _vm.styleObjectFailure)
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shippingIDs))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.message))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm mt-4",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel()
      }
    }
  }, [_vm._v("close")])])])])]), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.raiseRMDebitNoteEditflag = false
      }
    },
    model: {
      value: (_vm.raiseRMDebitNoteEditflag),
      callback: function($$v) {
        _vm.raiseRMDebitNoteEditflag = $$v
      },
      expression: "raiseRMDebitNoteEditflag"
    }
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Raise RM Debit Note - Edit ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeonPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.raiseRMDebitNoteData.length != 0) ? _c('div', [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('h5', [_vm._v("Shipping Id:" + _vm._s(_vm.raiseRMDebitNoteData[0].ShippingID))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 lg-auto"
  }, [_c('h5', [_vm._v("Total Debit Amount: " + _vm._s(_vm.amount))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('h5', [_vm._v(" Debit Concern Person ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 lg-auto"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        return _vm.selectItemsonPopup($event)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Debit Pending ")]), _vm._v(" "), _c('th', [_vm._v("Debit Share in Rs.")]), _vm._v(" "), _c('th', [_vm._v("Percentage")]), _vm._v(" "), _c('th', [_vm._v("Emp ID")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.raiseRMDebitNoteData), function(val, index) {
    return _c('tr', [(val.DebitFromType === 'Vendor' || val.DebitFromType === 'NetworkVendor') ? [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectEditItemsList),
        expression: "selectEditItemsList"
      }],
      attrs: {
        "type": "checkbox",
        "id": val.VehicleVendorID
      },
      domProps: {
        "value": val.VehicleVendorID,
        "checked": Array.isArray(_vm.selectEditItemsList) ? _vm._i(_vm.selectEditItemsList, val.VehicleVendorID) > -1 : (_vm.selectEditItemsList)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectEditItemsList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.VehicleVendorID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectEditItemsList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectEditItemsList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectEditItemsList = $$c
          }
        }, function($event) {
          return _vm.calculateDebitAmout(("" + _vm.amount), 100, ("" + (val.VehicleVendorID)))
        }]
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.DebitFrom))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonAmount[val.VehicleVendorID]),
        expression: "debitPersonAmount[val.VehicleVendorID]"
      }],
      attrs: {
        "type": "text",
        "id": ("debitshare" + (val.VehicleVendorID)),
        "name": "debitshare"
      },
      domProps: {
        "value": (_vm.debitPersonAmount[val.VehicleVendorID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitPercenatge(("" + (val.VehicleVendorID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonAmount, val.VehicleVendorID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonPercent[val.VehicleVendorID]),
        expression: "debitPersonPercent[val.VehicleVendorID]"
      }],
      attrs: {
        "type": "text",
        "name": "percentage",
        "id": ("percentage" + (val.VehicleVendorID))
      },
      domProps: {
        "value": (_vm.debitPersonPercent[val.VehicleVendorID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitAmout(("" + (val.VehicleVendorID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonPercent, val.VehicleVendorID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.VehicleVendorID))])] : (val.DebitFromType === 'ServiceCenter') ? [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectEditItemsList),
        expression: "selectEditItemsList"
      }],
      attrs: {
        "type": "checkbox",
        "id": val.UserID
      },
      domProps: {
        "value": val.UserID,
        "checked": Array.isArray(_vm.selectEditItemsList) ? _vm._i(_vm.selectEditItemsList, val.UserID) > -1 : (_vm.selectEditItemsList)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectEditItemsList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.UserID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectEditItemsList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectEditItemsList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectEditItemsList = $$c
          }
        }, function($event) {
          return _vm.calculateDebitAmout(("" + _vm.amount), 100, ("" + (val.UserID)))
        }]
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.DebitFrom))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonAmount[val.UserID]),
        expression: "debitPersonAmount[val.UserID]"
      }],
      attrs: {
        "type": "text",
        "id": ("debitshare" + (val.UserID)),
        "name": "debitshare"
      },
      domProps: {
        "value": (_vm.debitPersonAmount[val.UserID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitPercenatge(("" + (val.UserID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonAmount, val.UserID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonPercent[val.UserID]),
        expression: "debitPersonPercent[val.UserID]"
      }],
      attrs: {
        "type": "text",
        "name": "percentage",
        "id": ("percentage" + (val.UserID))
      },
      domProps: {
        "value": (_vm.debitPersonPercent[val.UserID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitAmout(("" + (val.UserID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonPercent, val.UserID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.UserID))])] : (val.DebitFromType === 'Coloader') ? [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectEditItemsList),
        expression: "selectEditItemsList"
      }],
      attrs: {
        "type": "checkbox",
        "id": val.ColoaderID
      },
      domProps: {
        "value": val.ColoaderID,
        "checked": Array.isArray(_vm.selectEditItemsList) ? _vm._i(_vm.selectEditItemsList, val.ColoaderID) > -1 : (_vm.selectEditItemsList)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectEditItemsList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.ColoaderID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectEditItemsList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectEditItemsList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectEditItemsList = $$c
          }
        }, function($event) {
          return _vm.calculateDebitAmout(("" + _vm.amount), 100, ("" + (val.ColoaderID)))
        }]
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.DebitFrom))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonAmount[val.ColoaderID]),
        expression: "debitPersonAmount[val.ColoaderID]"
      }],
      attrs: {
        "type": "text",
        "id": ("debitshare" + (val.ColoaderID)),
        "name": "debitshare"
      },
      domProps: {
        "value": (_vm.debitPersonAmount[val.ColoaderID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitPercenatge(("" + (val.ColoaderID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonAmount, val.ColoaderID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonPercent[val.ColoaderID]),
        expression: "debitPersonPercent[val.ColoaderID]"
      }],
      attrs: {
        "type": "text",
        "name": "percentage",
        "id": ("percentage" + (val.ColoaderID))
      },
      domProps: {
        "value": (_vm.debitPersonPercent[val.ColoaderID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitAmout(("" + (val.ColoaderID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonPercent, val.ColoaderID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.ColoaderID))])] : (val.DebitFromType === 'Courier') ? [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectEditItemsList),
        expression: "selectEditItemsList"
      }],
      attrs: {
        "type": "checkbox",
        "id": val.CourierID
      },
      domProps: {
        "value": val.CourierID,
        "checked": Array.isArray(_vm.selectEditItemsList) ? _vm._i(_vm.selectEditItemsList, val.CourierID) > -1 : (_vm.selectEditItemsList)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectEditItemsList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.CourierID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectEditItemsList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectEditItemsList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectEditItemsList = $$c
          }
        }, function($event) {
          return _vm.calculateDebitAmout(("" + _vm.amount), 100, ("" + (val.CourierID)))
        }]
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.DebitFrom))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonAmount[val.CourierID]),
        expression: "debitPersonAmount[val.CourierID]"
      }],
      attrs: {
        "type": "text",
        "id": ("debitshare" + (val.CourierID)),
        "name": "debitshare"
      },
      domProps: {
        "value": (_vm.debitPersonAmount[val.CourierID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitPercenatge(("" + (val.CourierID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonAmount, val.CourierID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonPercent[val.CourierID]),
        expression: "debitPersonPercent[val.CourierID]"
      }],
      attrs: {
        "type": "text",
        "name": "percentage",
        "id": ("percentage" + (val.CourierID))
      },
      domProps: {
        "value": (_vm.debitPersonPercent[val.CourierID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitAmout(("" + (val.CourierID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonPercent, val.CourierID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.CourierID))])] : (val.DebitFromType == 'Store' || val.DebitFromType == 'RSC' || val.DebitFromType == 'BranchDebit') ? [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectEditItemsList),
        expression: "selectEditItemsList"
      }],
      attrs: {
        "type": "checkbox",
        "id": val.DebitID
      },
      domProps: {
        "value": val.DebitID,
        "checked": Array.isArray(_vm.selectEditItemsList) ? _vm._i(_vm.selectEditItemsList, val.DebitID) > -1 : (_vm.selectEditItemsList)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectEditItemsList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.DebitID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectEditItemsList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectEditItemsList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectEditItemsList = $$c
          }
        }, function($event) {
          return _vm.calculateDebitAmout(("" + _vm.amount), 100, ("" + (val.DebitID)))
        }]
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.DebitFrom))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonAmount[val.DebitID]),
        expression: "debitPersonAmount[val.DebitID]"
      }],
      attrs: {
        "type": "text",
        "id": ("debitshare" + (val.DebitID)),
        "name": "debitshare"
      },
      domProps: {
        "value": (_vm.debitPersonAmount[val.DebitID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitPercenatge(("" + (val.DebitID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonAmount, val.DebitID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.debitPersonPercent[val.DebitID]),
        expression: "debitPersonPercent[val.DebitID]"
      }],
      attrs: {
        "type": "text",
        "name": "percentage",
        "id": ("percentage" + (val.DebitID))
      },
      domProps: {
        "value": (_vm.debitPersonPercent[val.DebitID])
      },
      on: {
        "change": function($event) {
          return _vm.adjustDebitAmout(("" + (val.DebitID)))
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.debitPersonPercent, val.DebitID, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DebitID))])] : _vm._e()], 2)
  }), 0)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('h5', [_vm._v("Comments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 lg-auto"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raiseRMDebitNotecomment),
      expression: "raiseRMDebitNotecomment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.raiseRMDebitNotecomment')
    },
    attrs: {
      "rows": "2",
      "name": "raiseRMDebitNotecomment",
      "id": "raiseRMDebitNotecomment"
    },
    domProps: {
      "value": (_vm.raiseRMDebitNotecomment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.raiseRMDebitNotecomment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.raiseRMDebitNotecomment')),
      expression: "errors.has('form-1.raiseRMDebitNotecomment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Comment.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDebitPersonSelected),
      expression: "isDebitPersonSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.personSelected')
    },
    attrs: {
      "type": "hidden",
      "name": "personSelected",
      "id": "personSelected"
    },
    domProps: {
      "value": (_vm.isDebitPersonSelected)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isDebitPersonSelected = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.personSelected')),
      expression: "errors.has('form-1.personSelected')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Debit Person.")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.debitNoteSubmit
    }
  }, [_vm._v("Approve")]), _vm._v(" \n                             "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": _vm.closeonPopup
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Close")])])])])]) : _vm._e(), _vm._v(" "), (_vm.raiseRMDebitNoteData.length == 0) ? _c('div', [_c('p', [_vm._v("No Records found")])]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.LoaderForPopup
    },
    on: {
      "update:active": function($event) {
        _vm.LoaderForPopup = $event
      }
    }
  })], 1)])])], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.getShipmentsflag = false
      }
    },
    model: {
      value: (_vm.getShipmentsflag),
      callback: function($$v) {
        _vm.getShipmentsflag = $$v
      },
      expression: "getShipmentsflag"
    }
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle link",
    on: {
      "click": function($event) {
        return _vm.getShipmentslog(_vm.getShippingIdforLog)
      }
    }
  }, [_vm._v("Shipment Log")]), _vm._v("    \n              "), _c('span', {
    staticClass: "mdltitle link",
    on: {
      "click": _vm.getShipmentsSummery
    }
  }, [_vm._v("Shipment Summery")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeonPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), (_vm.getShipmentslogData.length > 0) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('center', [_c('h5', [_vm._v("Shipment Log")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("BagNo")]), _vm._v(" "), _c('th', [_vm._v("ProcessLocation")]), _vm._v(" "), _c('th', [_vm._v("Process")]), _vm._v(" "), _c('th', [_vm._v("Comment")]), _vm._v(" "), _c('th', [_vm._v("CreatedDate")]), _vm._v(" "), _c('th', [_vm._v("CreatedBy\t")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getShipmentslogData), function(val) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(val.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.BagNo))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.ProcessLocation))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Process))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Comments))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.CreatedBy))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.getShipmentsSummeryData.length > 0) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('center', [_c('h5', [_vm._v("Shipment Summery")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Shipment Lost Audit LogID")]), _vm._v(" "), _c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("DebitFromType")]), _vm._v(" "), _c('th', [_vm._v("Process")]), _vm._v(" "), _c('th', [_vm._v("CreatedDate")]), _vm._v(" "), _c('th', [_vm._v("CreatedBy")]), _vm._v(" "), _c('th', [_vm._v("Comments")])])]), _vm._v(" "), _c('tbody', [(_vm.getShipmentsSummeryData.length == 0) ? [_c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No Data Available")])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.getShipmentsSummeryData), function(val) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(val.ShipmentLostAuditLogID))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DebitFromType))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Process))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.CreatedBy))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Comments))])])
  })], 2)])])])]) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.getDebitAmountflag = false
      }
    },
    model: {
      value: (_vm.getDebitAmountflag),
      callback: function($$v) {
        _vm.getDebitAmountflag = $$v
      },
      expression: "getDebitAmountflag"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Debit Amount ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeonPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("DebitPerson")]), _vm._v(" "), _c('th', [_vm._v("DebitShare")]), _vm._v(" "), _c('th', [_vm._v("EmployeeId")])])]), _vm._v(" "), _c('tbody', [(_vm.getDebitAmountData && _vm.getDebitAmountData.length > 0) ? _vm._l((_vm.getDebitAmountData), function(val) {
    return _c('tr', {
      key: val.DebitID
    }, [_c('td', [_vm._v(_vm._s(val.DebitFrom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.DebitAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDebitFromId(val)))])])
  }) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])])], 2)])])])])], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.getAttachmentFlag = false
      }
    },
    model: {
      value: (_vm.getAttachmentFlag),
      callback: function($$v) {
        _vm.getAttachmentFlag = $$v
      },
      expression: "getAttachmentFlag"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Attachment ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAttachmentPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [(_vm.getInvestigationImgs != 0) ? _c('div', {
    staticClass: "header",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "text-center",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("Investigation Images")])]) : _vm._e(), _vm._v(" "), (_vm.getInvestigationImgs != 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getInvestigationImgs), function(item, index) {
    return _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "margin": "15px 0px"
      }
    }, [(item.fileType != 'pdf') ? _c('div', {
      key: index,
      staticClass: "media-item",
      on: {
        "click": function($event) {
          return _vm.openModal(item)
        }
      }
    }, [(item.fileType === 'image') ? _c('img', {
      attrs: {
        "src": item.filePath,
        "alt": "Image"
      }
    }) : _vm._e(), _vm._v(" "), (item.fileType === 'video') ? _c('video', {
      attrs: {
        "src": item.filePath,
        "controls": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(item.fileType === 'pdf') ? _c('a', {
      attrs: {
        "href": "item.filePath",
        "target": "_blank",
        "download": "item.fileName"
      }
    }, [_vm._v(_vm._s(item.fileName))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getInvestigationImgs != 0) ? _c('hr', {
    staticStyle: {
      "margin": "15px 0px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "text-center",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("Raise Debit Images")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.getAttachmentListData.length == 0) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('p', {
    staticClass: "text-center",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("No Attachments Available.! ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getAttachmentListData), function(item, index) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [(item.fileType != 'pdf') ? _c('div', {
      key: index,
      staticClass: "media-item",
      on: {
        "click": function($event) {
          return _vm.openModal(item)
        }
      }
    }, [(item.fileType === 'image') ? _c('img', {
      attrs: {
        "src": item.filePath,
        "alt": "Image"
      }
    }) : _vm._e(), _vm._v(" "), (item.fileType === 'video') ? _c('video', {
      attrs: {
        "src": item.filePath,
        "controls": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(item.fileType === 'pdf') ? _c('a', {
      attrs: {
        "href": "item.filePath",
        "target": "_blank",
        "download": "item.fileName"
      }
    }, [_vm._v(_vm._s(item.fileName))]) : _vm._e()])])
  })], 2)])])])], 1), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-content imageView",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "close-button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")]), _vm._v(" "), (_vm.Itemselected.fileType === 'image') ? _c('img', {
    attrs: {
      "src": _vm.Itemselected.filePath,
      "alt": "Image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Itemselected.fileType === 'video') ? _c('video', {
    attrs: {
      "src": _vm.Itemselected.filePath,
      "controls": ""
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.debitFromModal = false
      }
    },
    model: {
      value: (_vm.debitFromModal),
      callback: function($$v) {
        _vm.debitFromModal = $$v
      },
      expression: "debitFromModal"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Debit Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDebitFromModal
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto",
    class: {
      'isScroll': _vm.isScroll
    }
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No")]), _vm._v(" "), _c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("Debit From Type")]), _vm._v(" "), _c('th', [_vm._v("Debit From (Employee Name)")]), _vm._v(" "), _c('th', [_vm._v("Delivery SR Id")]), _vm._v(" "), _c('th', [_vm._v("Vendor Name (Vendor Id)")]), _vm._v(" "), _c('th', [_vm._v("Debit Id")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.debitDetailsFull), function(val1, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val1.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.DebitFromType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.DebitFrom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.DeliveryUserID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.VendorNameAndID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.DebitID))])])
  }), 0)])])])])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ece7cdea","hasScoped":true}!./src/views/components/LOST/RMApprove/RMApprove.component.html
// module id = 1072
// module chunks = 1